import { render } from "./TitleWithWeightTarget.vue?vue&type=template&id=56beebe0&scoped=true"
import script from "./TitleWithWeightTarget.vue?vue&type=script&lang=js"
export * from "./TitleWithWeightTarget.vue?vue&type=script&lang=js"

import "./TitleWithWeightTarget.vue?vue&type=style&index=0&id=56beebe0&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56beebe0"],['__file',"src/components/title/TitleWithWeightTarget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56beebe0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56beebe0', __exports__)) {
    console.log('reload')
    api.reload('56beebe0', __exports__)
  }
  
  module.hot.accept("./TitleWithWeightTarget.vue?vue&type=template&id=56beebe0&scoped=true", () => {
    console.log('re-render')
    api.rerender('56beebe0', render)
  })

}


export default __exports__